import { fireUtagEvent } from '@garmin/support-analytics';
// eslint-disable-next-line import/no-cycle
import Utils from '../../../../lib/utils';
import PageTitle from '../../../../lib/pageTitle';
import { REGEX_ORMA_URL } from '../../../../config/constants';

export const getFormattedEmbeddedPrivateFaqContent = () => (privateContent) => {
  let formattedContent = privateContent;
  const toBeParsedAsLinks = privateContent.match(/<content>(.*?)<\/content>/g);
  const embeddedEntries = privateContent.match(/<entryId>(.*?)<\/entryId>/g);

  let faqIds = false;
  if (embeddedEntries !== null) {
    faqIds = embeddedEntries.map((val) => {
      if (val !== null) {
        return val.split('<id>').pop().split('</id').shift();
      }
      return false;
    });
  }

  if (toBeParsedAsLinks !== null) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < toBeParsedAsLinks.length; i++) {
      const faqTitle = toBeParsedAsLinks[i].split('<title>').pop().split('</title').shift();
      const embeddedPrivateFaqPattern = `
                        <a href="${Utils.getBaseUrl()}/${Utils.getLocale()}/?faq=${faqIds[i]}"
                        @click.prevent="$emit('embedded-private-faq-click', $event)"
                        data-content-id="${faqIds[i]}"
                        data-content-type="faq"
                        class="js__faq-link">${faqTitle}</a>
                  `;
      formattedContent = formattedContent.replace(toBeParsedAsLinks[i], embeddedPrivateFaqPattern);
    }
  }

  return formattedContent;
};

export const getFormattedEmbeddedFaqContent = () => (embeddedContent, content) => {
  let formattedContent = content;
  Object.keys(embeddedContent).forEach((faqId) => {
    const faqHrefPattern = new RegExp(`href="${faqId}"`, 'g');
    const faqLinkFormatted = `
              href="${Utils.getBaseUrl()}/${Utils.getLocale()}/?faq=${faqId}"
              @click.prevent="$emit('embedded-faq-click', $event)"
              data-content-id="${faqId}"
              data-content-type="faq"
              class="js__faq-link"
          `;
    formattedContent = formattedContent.replace(faqHrefPattern, faqLinkFormatted);
  });
  return formattedContent;
};

export const formatFaqInPageAnchors = () => (faqContent) => {
  const faqContentNode = document.createElement('div');
  faqContentNode.innerHTML = faqContent;
  const anchorNodes = Array.from(faqContentNode.querySelectorAll('a[href^="#"]'));
  const allAnchorNodes = Array.from(faqContentNode.getElementsByTagName('a'));
  let formattedContent = faqContent;

  if (anchorNodes && anchorNodes.length > 0) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < anchorNodes.length; i++) {
      const qSelector = anchorNodes[i].hash;
      const { outerHTML } = anchorNodes[i];

      const newTag = `
          ${outerHTML.split('>')[0]}
          @click.prevent="$emit('onAnchorClick', '${qSelector}')">
          ${outerHTML.split('>')[1]}>
          `;

      formattedContent = formattedContent.replace(outerHTML, newTag);
    }
  }

  if (allAnchorNodes && allAnchorNodes.length) {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const index in allAnchorNodes) {
      const aNode = allAnchorNodes[index];
      if (aNode.href.match(REGEX_ORMA_URL)) {
        const { outerHTML } = aNode;
        const newTag = `
            ${outerHTML.split('>')[0]}
            @click="$emit('onORMAAnchorClick')">
            ${outerHTML.split('>')[1]}>
            `;
        formattedContent = formattedContent.replace(outerHTML, newTag);
      }
    }
  }

  return formattedContent;
};

export const updateDocumentTitleFaq = (faq, product, nonHomePageTitle, tab, topic, sasSource) => {
  if ((faq?.title || '').length) {
    if (product?.displayName) {
      PageTitle.constructTitle([
        faq.title,
        product.displayName,
        nonHomePageTitle,
      ]);
    } else {
      PageTitle.constructTitle([faq.title, nonHomePageTitle]);
    }

    fireUtagEvent({
      event_category: Utils.getAnalyticsEventCategoryFromTabName(tab),
      event_action: 'FAQ View',
      event_label: `${faq.publishedId} - ${faq.title}`,
      product_name: product?.displayName,
      ps_topic: topic,
      ps_sas_source: sasSource,
    });
  }
};

export const addExpandCollapseButton = () => (faqContent, isPrivate = false) => {
  const faqContentNode = document.createElement('div');
  faqContentNode.innerHTML = faqContent;

  const firstHr = faqContentNode.querySelector('hr');

  const expandCollapseButton = `
    <div class="sc__article__content__button--container${isPrivate || firstHr ? '--no-border' : ''}">
      <button class="sc__article__content__button" 
        @click.prevent="$emit('expandCollapseAll', $event)">
      </button>
    </div>
  `;

  if (!isPrivate) {
    const firstCollapseContent = faqContentNode.querySelector('.GTCollapseContent');
    if (firstCollapseContent) {
      firstCollapseContent.insertAdjacentHTML('beforebegin', expandCollapseButton);
    }
  } else if (firstHr) {
    firstHr.insertAdjacentHTML('beforebegin', expandCollapseButton);
  }

  // eslint-disable-next-line no-param-reassign
  faqContent = faqContentNode.innerHTML;

  return faqContent;
};
